import { safeExportFilename } from '../../lib/exportCells.js';
import { downloadBlob } from '../../lib/downloadBlob.js';

/**
 * Export CSV WYSIWYG d'un tableau (lignes déjà chargées avec les filtres + unité
 * courante). Client-side, pas de requête serveur séparée.
 *
 * - Neutralise la CSV/formula injection (préfixe `'` sur cellule commençant par
 *   = + - @ tab CR), cohérent avec exportXlsx (F-S22-01).
 * - Échappe les valeurs (guillemets doublés, encadrement si , ; " ou saut de ligne).
 * - BOM UTF-8 pour qu'Excel ouvre correctement les accents.
 *
 * @param {Array<Object>} rows
 * @param {Array<{key:string,label:string,format?:(v:any,row:Object)=>any}>} columns
 * @param {string} filename  (sans extension)
 * @param {string} [delimiter=';']  séparateur (';' = défaut Excel FR)
 */
export function exportRowsToCsv(rows, columns, filename = 'export', delimiter = ';') {
  const sanitize = (v) => {
    if (typeof v === 'string' && /^[=+\-@\t\r]/.test(v)) return `'${v}`;
    return v;
  };
  const escape = (v) => {
    const s = v == null ? '' : String(sanitize(v));
    if (s.includes('"') || s.includes(delimiter) || s.includes('\n') || s.includes('\r')) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };

  const header = columns.map((c) => escape(c.label)).join(delimiter);
  const body = (rows ?? []).map((row) =>
    columns
      .map((c) => escape(c.format ? c.format(row[c.key], row) : row[c.key]))
      .join(delimiter),
  );
  const csv = '﻿' + [header, ...body].join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, `${safeExportFilename(filename)}.csv`);
}
